module.exports = __webpack_public_path__ + "media/emoji_icons/high-b2662375.svg";